(ns app.zap-vault.vault-selection.view
  (:require
   [app.zap-vault.event :as event]
   [app.zap-vault.sub :as sub]
   [app.zap-vault.no-access.view :as no-access]
   [common.dates :as dates]
   [common.localization :as loc]
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.components.alert-list.view :as alert-list]
   [ui.components.button.view :as button]))


(defn processing
  []
  [:div
   {:class-name "p-6 flex justify-center"}
   "Processing"])

(defn view
  []
  (let [accessible-zap-vaults @(rf/subscribe [::sub/accessible-zap-vaults])
        processing? @(rf/subscribe [::sub/processing?])]
    [:div
     {:class "position-fixed w-full h-full flex flex-col flex-1 bg-base-light"}
     [alert-list/view :login-notifications]
     (if processing?
       [processing]
       [:div
        {:class "flex flex-col h-full"}
        (if (empty? accessible-zap-vaults)
          [no-access/view]
          [:<>
           [:div
            {:class "px-4 w-full flex flex-col flex-1 gap-3 overflow-y-auto"}
            [:div
             {:class "max-w-[1024px] w-full mx-auto"}
             [:h2
              {:class "py-4 flex gap-2 text-xl font-semibold"}
              (loc/tr :login-available-zap-vaults)]
             [:ul
              {:class "flex flex-col flex-1"}
              (some->>
               accessible-zap-vaults
               (map (fn [s]
                      ^{:key (str "zap-vault-item-" (:id s))}
                      [:li
                       {:class    (uu/cm "grid grid-cols-10 py-2 px-2 gap-4
                                                                 text-complement-light-text
                                                                 border-b border-solid border-base-light-border-paler"
                                         "hover:bg-base-regular pointer"
                                         "align-items-center")
                        :on-click #(rf/dispatch [::event/select-zap-vault (:id s)])}
                       [:div
                        {:class "flex items-baseline gap-3 col-span-5 md:col-span-6"}
                        [:span
                         {:class "text-info-regular"}
                         [:i.fa-duotone.fa-thin.fa-ballot-check]]
                        [:div
                         {:class "flex flex-auto flex-col"}
                         (:label s)]]
                       [:div
                        {:class "grid grid-cols-2 gap-4 align-items-center col-span-5 md:col-span-4"}
                        [:div
                         {:class "text-xs m-0"}
                         (when-let [start-ts (:timestamp-period-start s)]
                           (let [end-ts (:timestamp-period-end s)
                                 start-of-month (dates/date-time start-ts)
                                 end-of-month (dates/date-time end-ts)]
                             (str (when-not (= end-ts start-ts)
                                    (dates/format start-of-month {:pattern "dd.MM"}))
                                  (when-not (= end-ts start-ts)
                                    " - ")
                                  (dates/format end-of-month {:pattern "dd.MM.yyyy"}))))
                         (when-let [invite-date-ms (:invite-date s)]
                           (dates/format (dates/date invite-date-ms)
                                         {:format "d-MMM-yyyy"}))]
                        [:div
                         {:class "flex justify-end"}
                         [:div
                          {:class (uu/cm "px-4 py-1 rounded-full text-xs font-semibold"
                                         (case (:status s)
                                           :zap-vault-process.status/wip "bg-info-light bg-text-info-light-text border border-info-light-border-paler text-info-light-text"
                                           :zap-vault-process.status/draft "bg-warning-light bg-text-warning-light-text border border-warning-light-border"
                                           :zap-vault-process.status/prefilled "bg-warning-light bg-text-warning-light-text border border-warning-light-border"
                                           "bg-primary-light bg-text-primary-light-text border border-primary-light-border"))}
                          (case (:status s)
                            :zap-vault-process.status/wip (loc/tr :zap-vault-status-wip)
                            :zap-vault-process.status/draft (loc/tr :zap-vault-status-waiting)
                            :zap-vault-process.status/prefilled (loc/tr :zap-vault-status-waiting)
                            (loc/tr :zap-vault-status-review-submission))]]]]))
               (doall))]]]
           [:div
            {:class "w-full pt-3 max-w-[1024px] mx-auto my-3 flex justify-end gap-2 text-center border-t border-solid border-base-regular-border-paler"}
            [button/primary-solid
             {:on-click #(rf/dispatch [::event/logout])}
             (loc/tr :logout)]]])])]))

